// HoverTooltip.js - Lightweight tooltip on hover

import React, { useState, useEffect, useRef } from 'react';
import { CATEGORIES, formatYear } from '../data/events';

export function HoverTooltip({ event }) {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const ref = useRef(null);

  useEffect(() => {
    const move = (e) => setPos({ x: e.clientX + 16, y: e.clientY - 8 });
    window.addEventListener('mousemove', move);
    return () => window.removeEventListener('mousemove', move);
  }, []);

  if (!event) return null;
  const cat = CATEGORIES[event.category];

  return (
    <div
      ref={ref}
      className="hover-tooltip"
      style={{ left: pos.x, top: pos.y }}
    >
      <div className="tt-header">
        <span className="tt-icon">{cat.icon}</span>
        <span className="tt-year" style={{ color: cat.color }}>{formatYear(event.year)}</span>
      </div>
      <div className="tt-title">{event.title}</div>
      <div className="tt-hint">Cliquer pour plus d'infos</div>
    </div>
  );
}
